module.exports = __webpack_public_path__ + "static/image/merchants-unrelated.svg?dbdfcdc898cecfcaa9d94e6bf8796e0f";